// @flow

// Constants
import {
  MANAGEMENT_ZONES,
} from 'fc-model-assets'

// Selectors
import makeAssetsOfCategory from './composers/makeAssetsOfCategory'

// Exports
export default makeAssetsOfCategory({
  category: MANAGEMENT_ZONES,
})
